import { createTheme, type Theme } from '@mui/material/styles';
import { citiboxColors } from './colors';
import { FONT_FAMILY_BODY } from './typography';

export interface CitiboxThemeOptions {
  mode?: 'light';
}

/**
 * Build the single Citibox Material theme: the brand palette (Electric Purple,
 * #7942ED) and Lato typography, sourced from ./colors and ./typography so the
 * named tokens and the live theme can never drift. Global shape and button
 * casing stay at MUI defaults; per-component brand shaping (pill inputs, the
 * search-shell header, …) lives in the components, not here. See docs/DESIGN.md §2.
 */
export const createCitiboxTheme = (_options: CitiboxThemeOptions = {}): Theme => {
  return createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: citiboxColors.primary,
        dark: citiboxColors.primaryDark,
        light: citiboxColors.primaryLight,
      },
      secondary: { main: citiboxColors.secondary, dark: citiboxColors.secondaryDark },
      success: { main: citiboxColors.success },
      warning: { main: citiboxColors.warning },
      error: { main: citiboxColors.error },
      info: { main: citiboxColors.info },
      text: { primary: citiboxColors.textPrimary, secondary: citiboxColors.textSecondary },
      // The page sits on the surface gray; Paper (cards, the active enclosed tab)
      // stays white so it lifts off the chrome. See docs/DESIGN.md §2.
      background: { default: citiboxColors.surface, paper: citiboxColors.background },
      divider: citiboxColors.divider,
    },
    typography: { fontFamily: FONT_FAMILY_BODY },
  });
};

export { citiboxColors } from './colors';
export { FONT_FAMILY_BODY, FONT_FAMILY_MONO, FONT_SIZE_BASE, fontWeights } from './typography';
